import { AsyncStateNotification } from '@ui/notifications';
import { coreActions } from '@sonar-software/sonar-core';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { useCreateInitiativeTask } from '@hooks';

export const CreateTaskNotification: React.FC = () =>
	<AsyncStateNotification
		errored={ NOTIFICATIONS_COPY.ERROR_CREATE_INITIATVE_TASK }
		failed={ NOTIFICATIONS_COPY.FAILED_CREATE_INITIATIVE_TASK }
		received={ NOTIFICATIONS_COPY.SUCCESS_CREATE_INITIATIVE_TASK }
		resetRawAction={ coreActions.resetPostCoreInitiativesTasks }
		stateSelector={ useCreateInitiativeTask.selectors.state } />;

